/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Data with multiple fields that you can associate to a payment and that you can search with GetPaymentDetails.
 * @export
 * @interface PrivateData
 */
export interface PrivateData {
    /**
     * Up to 20 fields of 256 maximum length
     * @type {Array<string>}
     * @memberof PrivateData
     */
    value?: Array<string>;
}

/**
 * Check if a given object implements the PrivateData interface.
 */
export function instanceOfPrivateData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrivateDataFromJSON(json: any): PrivateData {
    return PrivateDataFromJSONTyped(json, false);
}

export function PrivateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function PrivateDataToJSON(value?: PrivateData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

